import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Organisation,
  OrganisationInviteUser,
  OrganisationUser,
} from '../../interfaces/organisation.interface';
import { OrganisationOrderOverview, OrganisationUserOverview } from '../../interfaces/organisation-overview.interface';
import { UserRole } from '../../interfaces/user.interface';

export const OrganisationActions = createActionGroup({
  source: 'Organisation',
  events: {
    Get: props<{ id: string }>(),
    'Get success': props<{ data: Organisation }>(),
    'Get failure': props<{ error: HttpErrorResponse }>(),
    
    'Get user': props<{ id: string }>(),
    'Get user success': props<{ data: OrganisationUser }>(),
    'Get user failure': props<{ error: HttpErrorResponse }>(),
    
    'Get all users': emptyProps(),
    'Get all users success': props<{ data: OrganisationUser[] }>(),
    'Get all users failure': props<{ error: HttpErrorResponse }>(),
    
    'Get users': emptyProps(),
    'Get users success': props<{ data: OrganisationUser[] }>(),
    'Get users failure': props<{ error: HttpErrorResponse }>(),

    'Get user overview': emptyProps(),
    'Get user overview success': props<{ data: OrganisationUserOverview }>(),
    'Get user overview failure': props<{ error: HttpErrorResponse }>(),
    
    'Get order overview': emptyProps(),
    'Get order overview success': props<{ data: OrganisationOrderOverview }>(),
    'Get order overview failure': props<{ error: HttpErrorResponse }>(),

    'Invite resend': props<{ email: string }>(),
    'Invite resend success': props<{ user: OrganisationUser }>(),
    'Invite resend failure': props<{ error: HttpErrorResponse }>(),
    
    'Invite user': props<{ user: OrganisationInviteUser }>(),
    'Invite user success': props<{ user: OrganisationUser }>(),
    'Invite user failure': props<{ error: HttpErrorResponse }>(),
    
    'Remove user': props<{ id: string }>(),
    'Remove user success': props<{ user: OrganisationUser }>(),
    'Remove user failure': props<{ error: HttpErrorResponse }>(),
    
    'Update user role': props<{ userId: string; role: UserRole }>(),
    'Update user role success': props<{ user: OrganisationUser }>(),
    'Update user role failure': props<{ error: HttpErrorResponse }>(),
    
    'Clear error state': emptyProps(),
    'Clear state': emptyProps(),
  },
});
